export const ADD_DITTO_LOAD = 'ditto/ADD_DITTO_LOAD';
export const ADD_DITTO_SUCCESS = 'ditto/ADD_DITTO_SUCCESS';
export const ADD_DITTO_FAIL = 'ditto/ADD_DITTO_FAIL';


export const SAVE_UPDATE_DITTO_LOAD = 'ditto/SAVE_UPDATE_DITTO_LOAD';
export const SAVE_UPDATE_DITTO_SUCCESS = 'ditto/SAVE_UPDATE_DITTO_SUCCESS';
export const SAVE_UPDATE_DITTO_FAIL = 'ditto/SAVE_UPDATE_DITTO_FAIL';



